import React, { } from 'react';
import { Box } from '@material-ui/core';
import ClientNotesDialog from './components/ClientNotesDialog';
import PRTableFullView from './components/PRTableFullView';
import useLoadActiveFullView from './hooks/useLoadActiveFullView';
import LinksDialog from './components/LinksDialog';

const ActiveCampaignsFullView = () => {
    useLoadActiveFullView();

   return (<Box>
      <PRTableFullView />
      <ClientNotesDialog />
      <LinksDialog />
   </Box>)
}

export default ActiveCampaignsFullView;